import {
  MeetingFilterMatchType,
  MeetingFilterOperator,
  MeetingFilterRule,
  MeetingFilterRuleGroup,
  MeetingFilterType,
  TServerErrorResponse,
} from "@/types";
import { http } from "@/api/httpHandler";
import { links } from "@/constants";

export const MEETING_FILTER_RULE_GROUPS_GET =
  "meeting-filter-rule-groups-get";

export const getMeetingFilterRuleGroups = async () => {
  try {
    const response = await http.get<MeetingFilterRuleGroup[]>(
      links.meetingFilterRuleGroup.index,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createMeetingFilterRuleGroup = async (data: {
  matchType: MeetingFilterMatchType;
  rules: {
    filterType: MeetingFilterType;
    operator: MeetingFilterOperator;
    pattern: string;
  }[];
}) => {
  try {
    const response = await http.post<MeetingFilterRuleGroup>(
      links.meetingFilterRuleGroup.index,
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeetingFilterRuleGroup = async (
  id: string,
  data: { matchType: MeetingFilterMatchType },
) => {
  try {
    const response = await http.patch<MeetingFilterRuleGroup>(
      links.meetingFilterRuleGroup.byId(id),
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteMeetingFilterRuleGroup = async (
  id: string,
): Promise<void> => {
  try {
    await http.delete(links.meetingFilterRuleGroup.byId(id));
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const reorderMeetingFilterRuleGroups = async (data: {
  groupIds: string[];
}): Promise<void> => {
  try {
    await http.put(links.meetingFilterRuleGroup.reorder, data);
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createMeetingFilterRule = async (
  groupId: string,
  data: {
    filterType: MeetingFilterType;
    operator: MeetingFilterOperator;
    pattern: string;
  },
) => {
  try {
    const response = await http.post<MeetingFilterRule>(
      links.meetingFilterRuleGroup.rules(groupId),
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeetingFilterRule = async (
  groupId: string,
  ruleId: string,
  data: Partial<{
    filterType: MeetingFilterType;
    operator: MeetingFilterOperator;
    pattern: string;
  }>,
) => {
  try {
    const response = await http.patch<MeetingFilterRule>(
      links.meetingFilterRuleGroup.ruleById(groupId, ruleId),
      data,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteMeetingFilterRule = async (
  groupId: string,
  ruleId: string,
): Promise<void> => {
  try {
    await http.delete(
      links.meetingFilterRuleGroup.ruleById(groupId, ruleId),
    );
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
